import axios from 'axios';

import client from '../app/utils/auth-client';
import constants from '../app/config/constants';

/**
 * Get label address by country
 */
export const getLabelAddress = async country => {
  try {
    const token = await client.getToken();
    const result = await axios.get(`${constants.baseUrl}/labeladdress`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return result.data.data;
  } catch (error) {
    return {
      id: 1,
      address: 'Direccion',
      comuna: 'Comuna',
      zipcode: 'Codigo Postal',
      province: 'Provincia',
      country_id: 1,
      flg_address: 1,
      flg_comuna: 1,
      flg_zipcode: 1,
      flg_province: 1
    };
  }
};
